import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import API, { UPLOADS_URL } from '../api/axios';
import SEO from '../components/SEO';
import PageBanner from '../components/PageBanner';

const DynamicPage = () => {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [seo, setSeo] = useState(null);
  const [loading, setLoading] = useState(true);

  const skipSlugs = [
    'about-us',
    'about',
    'about-standrews-group',
    'about-group',
    'principals-message',
    'principals-desk',
    'admission',
    'admission-guidelines',
    'academics',
    'facilities',
    'core-values',
    'our-philosophy',
    'curriculum',
    'fees',
    'fee-structure',
    'extra-curricular-activities',
    'extra-curriculum-activities',
    'infrastructure',
    'beyond-classroom',
    'student-engagement',
    'other-facilities',
    'our-programmes',
    'recognition',
    'gallery',
    'events',
    'news',
    'blog',
    'contact-us',
  ];

  useEffect(() => {
    if (skipSlugs.includes(slug)) return;
    const fetchPage = async () => {
      try {
        const res = await API.get(`/pages/public/${slug}`);
        setPage(res.data.data);
        setSeo(res.data.seo);
      } catch (err) { setPage(null); }
      finally { setLoading(false); }
    };
    fetchPage();
  }, [slug]);

  if (skipSlugs.includes(slug)) return null;

  if (loading) return <div className="loading-screen"><i className="fas fa-spinner fa-spin"></i></div>;

  if (!page) return (
    <div className="error-message">
      <i className="fas fa-exclamation-circle"></i>
      <h2>Page Not Found</h2>
      <p>The page you're looking for doesn't exist.</p>
      <Link to="/" className="text-primary mt-4 inline-block">Go Home</Link>
    </div>
  );

  return (
    <>
      <SEO slug={slug} title={seo?.meta_title || page.title} description={seo?.meta_description || page.content?.replace(/<[^>]*>/g, '').substring(0, 160)} keywords={seo?.meta_keywords} />
      <PageBanner
        title={page.title}
        subtitle="St. Andrews World School, Sonipat"
        breadcrumb={page.title.toUpperCase()}
        bgImage={page.banner_image ? `${UPLOADS_URL}/${page.banner_image}` : null}
        fallback='/images/page-banners/why-choose-us.jpg'
      />

      <section className="content-page">
        <div className="container">
          <h1 className="h-section mb-6">{page.title}</h1>
          <div dangerouslySetInnerHTML={{ __html: page.content }} />
        </div>
      </section>
    </>
  );
};

export default DynamicPage;
